const { graphql, commitMutation } = require('react-relay');

const mutation = graphql`
    mutation InitiateCallMutation($input: InitiateCallInput!) {
        initiateCall(input: $input) {
            success
            errors {
                message
            }
        }
    }
`;

function commit(environment, args) {
    const {
        buyerId,
        saveName,
        savePhoneNumber,
        phoneCallbackEnabled,
        buyerName,
        buyerNumber,
        buyerCountryCode,
        itemId,
        itemName,
        dealerId,
        onSuccess,
        onFailure,
    } = args;

    const input = {
        buyerId,
        saveName,
        savePhoneNumber,
        phoneCallbackEnabled,
        buyerName,
        buyerNumber,
        buyerCountryCode,
        itemId,
        itemName,
        dealerId,
    };

    commitMutation(environment, {
        mutation,
        variables: { input },
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
                return;
            }
            onSuccess(payload);
        },
        onError: error => {
            onFailure([error]);
        },
    });
}

export default { commit };
